import {Box, Flex, Radio, RadioGroup, Text, Divider, Spacer, Heading} from '@chakra-ui/react';
import BoxCard from '../../components/General/BoxCard';
import LinkButton from '../../components/General/LinkButton';
import {CustomCheckbox, TimePicker, SubmitButton} from '../../components/General/FormInputs';
import React, {useState, useEffect, useRef} from 'react';
import SurveyTypesReports from '../../components/Reports/SurveyTypesReports';
import FormCodes from '../../constants/FormCodes';
import CriteriaCard from '../../components/Reports/CriteriaCard';
import ErrorHelper from '../../service/ErrorHelper';
import LoadingWheel from '../../components/General/LoadingWheel';
import {Report} from '../../service/Urls';
import {get, getReport} from '../../service/ApiService';
import {useForm, Controller} from 'react-hook-form';
import {CustomInput, DatePicker} from '../../components/General/FormInputs';
import Visibility from '../../constants/Visibility';
import {ClientSelect} from '../../components/Client/ClientSelect';
import FlexCard from '../../components/General/FlexCard';
import {useTitle} from '../../components/General/Layout';
import {getServiceTypes} from '../../helpers/ServiceTypeDictionary';

const serviceTypes = getServiceTypes().map(({value}) => value);

const SurveyReports = () => {
  // current selected report
  const [title, setTitle] = useTitle('');
  const [reportVal, setReportVal] = useState('');

  // current selected radio button id, needed for radio control
  const [promptId, setPromptId] = useState('');

  // currently selected service type
  const [serviceTypeValue, setServiceTypeValue] = useState(1);

  // list of report data
  const [sectionList, setSectionsList] = useState('');

  // current sectionId
  const [sectionId, setSectionId] = useState('');
  const [isLoading, setLoading] = useState(true);
  const [isInitialLoading, setInitialLoading] = useState(true);
  const [batch1, setBatch1] = useState('');
  const [batch2, setBatch2] = useState('');
  const [toast, setToast] = useState({});
  const [pdfUrl, setPdfUrl] = useState('');
  const linkRef = useRef(null);
  console.log(reportVal);
  const {
    register,
    handleSubmit,
    control,
    getValues,
    setValue,
    formState: {errors},
  } = useForm();

  useEffect(() => {
    loadData();
  }, []);

  // once the pdf url is loaded click the hidden link to open a new tab
  useEffect(() => {
    if (pdfUrl) linkRef.current.click();
  }, [pdfUrl]);

  useEffect(() => {
    if (Array.isArray(sectionList)) {
      sectionList.forEach(section => {
        const obj = section.reports.find(obj => {
          return obj.promptId === promptId;
        });

        if (typeof obj !== 'undefined') {
          setReportVal(obj);
        }
      });
    }
  }, [promptId]);

  const loadData = async () => {
    const data = await get(Report.LIST + `/` + FormCodes.SURVEY_REPORTS);
    setToast(data);
    if (!data.error) {
      const sections = data.data;
      if (sections) {
        setPromptId(sections[0].reports[0].promptId);
        setSectionsList(sections);
        setSectionId(sections[0].sectionId);
        setReportVal(sections[0]?.reports[0]);
      }
    }
    setInitialLoading(false);
    setLoading(false);
    setTitle('Survey Reports');
  };

  const updateBatch = () => {
    const val = getValues().startBatch;
    if (val && batch2 === '') {
      setBatch2(val);
      setValue('endBatch', val);
    }
  };

  useEffect(() => {
    defaultDates();
  }, [reportVal]);

  const defaultDates = () => {
    const formValues = getValues();
    const Today = new Date().toISOString().split('T')[0];
    if (reportVal.hasOwnProperty('startDateState')) setValue('startDate', formValues.startDate || Today);
    if (reportVal.hasOwnProperty('endDateState')) setValue('endDate', formValues.endDate || Today);
  };

  const filterFields = data => {
    if (!reportVal.hasOwnProperty('secondaryArrangerState')) data.secondaryArranger = false;
    if (!reportVal.hasOwnProperty('startDateState')) data.startDate = '';
    if (!reportVal.hasOwnProperty('endDateState')) data.endDate = '';
    if (!reportVal.hasOwnProperty('startTimeState')) data.startTime = '';
    if (!reportVal.hasOwnProperty('endTimeState')) data.endTime = '';
    if (!reportVal.hasOwnProperty('startBatchState')) data.startBatch = '';
    if (!reportVal.hasOwnProperty('endBatchState')) data.endBatch = '';
    if (!reportVal.hasOwnProperty('emailOnlyState')) data.isEmailOnly = false;
    if (!reportVal.hasOwnProperty('includeEmailState')) data.includeEmail = false;
    if (!reportVal.hasOwnProperty('openBatchOnlyState')) data.isOpenBatchesOnly = false;
    if (!reportVal.hasOwnProperty('noneReceivedState')) data.isNoneReceived = false;
    if (!reportVal.hasOwnProperty('inactiveArrangersState')) data.includeInactiveArrangers = false;
    if (!reportVal.hasOwnProperty('importAnalysisState')) data.impAnalysisContractOrImport = null;
  };

  const submit = async data => {
    setLoading(true);
    // data.startBatch = batch1;
    data.endBatch = batch2;
    data.formCode = FormCodes.SURVEY_REPORTS;
    data.serviceType = serviceTypeValue;
    data.sectionId = sectionId;
    data.promptId = reportVal.promptId;
    if (data.importAnalysis) data[data.importAnalysis] = true;
    filterFields(data);
    const reportName = await getReport(data);
    setToast(reportName);
    if (reportName) {
      if (reportName.error) {
        setToast(reportName);
      } else {
        setPdfUrl(reportName);
      }
    }
    setLoading(false);
  };

  return (
    <>
      <a href={pdfUrl} target="_blank" rel="noopener noreferrer" ref={linkRef} style={{display: 'none'}} />
      {isInitialLoading ? (
        <LoadingWheel />
      ) : (
        <form onSubmit={handleSubmit(submit)}>
          <Flex>
            {/* Sections */}
            <Box mx="3">
              {sectionList &&
                sectionList?.map(section => {
                  return (
                    <CriteriaCard value={promptId} setValue={setPromptId} reportInfo={section} key={section.sectionId} setSectionId={setSectionId}>
                      reports
                    </CriteriaCard>
                  );
                })}
            </Box>

            {/* Service Types */}
            <Box>
              <FlexCard>
                <SurveyTypesReports serviceTypeValue={serviceTypeValue} setServiceTypeValue={setServiceTypeValue} serviceTypes={serviceTypes} />
              </FlexCard>
            </Box>

            {/* Report Options */}
            <Box mx="3" textAlign={'start'}>
              <BoxCard>
                <Heading>Report Options</Heading>
                <Divider my="3" />
                <DatePicker
                  register={register}
                  errors={errors}
                  name="Starting Date"
                  id="startDate"
                  required={reportVal?.startDateState === Visibility.REQUIRED}
                  disabled={!reportVal.hasOwnProperty('startDateState')}
                />
                <DatePicker
                  register={register}
                  errors={errors}
                  name="Ending Date"
                  id="endDate"
                  required={reportVal?.endDateState === Visibility.REQUIRED}
                  disabled={!reportVal.hasOwnProperty('endDateState')}
                />
                <Divider my="3" />

                <Flex alignItems="center" gap={2}>
                  <Text>Enter Time Between</Text>
                  <TimePicker
                    register={register}
                    id={'startTime'}
                    errors={errors}
                    required={reportVal?.startTimeState === Visibility.REQUIRED}
                    disabled={!reportVal.hasOwnProperty('startTimeState')}
                  />
                  <Text>and</Text>
                  <TimePicker
                    register={register}
                    id={'endTime'}
                    errors={errors}
                    required={reportVal?.endTimeState === Visibility.REQUIRED}
                    disabled={!reportVal.hasOwnProperty('endTimeState')}
                  />
                </Flex>

                <Divider my="3" />
                <Flex>
                  <Text mt="-2" mr="8">
                    From Batch
                  </Text>
                  <CustomInput
                    register={register}
                    id={'startBatch'}
                    onBlur={() => updateBatch()}
                    errors={errors}
                    required={reportVal?.startBatchState === Visibility.REQUIRED}
                    disabled={!reportVal.hasOwnProperty('startBatchState')}
                  />
                  <Text mx="4">To</Text>
                  <CustomInput
                    register={register}
                    id={'endBatch'}
                    value={batch2}
                    onChange={e => setBatch2(e.target.value)}
                    errors={errors}
                    required={reportVal?.endBatchState === Visibility.REQUIRED}
                    disabled={!reportVal.hasOwnProperty('endBatchState')}
                  />
                </Flex>

                <Divider my="3" />
                <CustomCheckbox
                  id="isEmailOnly"
                  name="Batch Summary - Email/Text Only"
                  control={control}
                  disabled={!reportVal.hasOwnProperty('emailOnlyState')}
                />
                <CustomCheckbox
                  id="includeEmail"
                  name="Include Email/Text Returns"
                  control={control}
                  disabled={!reportVal.hasOwnProperty('includeEmailState')}
                />

                <Divider my="3" />
                <ClientSelect
                  register={register}
                  errors={errors}
                  id={'clientCode'}
                  required={reportVal?.clientIdState === Visibility.REQUIRED}
                  disabled={!reportVal.hasOwnProperty('clientIdState')}
                  setRHFValue={setValue}
                />

                <Divider my="3" />
                <Heading size={'md'} mb="3">
                  Import Analysis Options
                </Heading>

                <Flex>
                  <Controller
                    name="impAnalysisContractOrImport"
                    control={control}
                    render={({field}) => (
                      <RadioGroup {...field} colorScheme="tertiary" isDisabled={!reportVal.hasOwnProperty('importAnalysisState')}>
                        <Radio mr="5" value="IsContractDate">
                          Contract Date
                        </Radio>
                        <Radio value="IsImportDate">Import Date</Radio>
                      </RadioGroup>
                    )}
                    rules={{
                      required: {value: reportVal?.ImportAnalysisState === Visibility.REQUIRED, message: 'Field required.'},
                    }}
                  />
                </Flex>
                {errors['impAnalysisContractOrImport']?.type === 'required' && (
                  <Text ml="6" color="red.400" fontSize="sm">
                    *field is required
                  </Text>
                )}

                <Divider my="3" />
                <Flex>
                  <CustomCheckbox
                    id="isOpenBatchesOnly"
                    name="Open Batches Only"
                    control={control}
                    disabled={!reportVal.hasOwnProperty('openBatchOnlyState')}
                  />
                  <CustomCheckbox
                    id="isNoneReceived"
                    name="None Received"
                    control={control}
                    disabled={!reportVal.hasOwnProperty('noneReceivedState')}
                  />
                </Flex>

                <Divider my="3" />
                <CustomCheckbox
                  id="includeInactiveArrangers"
                  name="Include Inactive Arrangers"
                  control={control}
                  disabled={!reportVal.hasOwnProperty('inactiveArrangersState')}
                />

                <Divider my="3" />
                {isLoading ? (
                  <Flex justify={'center'}>
                    <LoadingWheel />
                  </Flex>
                ) : (
                  <>
                    <Flex>
                      <Box w="45%">
                        <LinkButton to="/" label="Back" />
                      </Box>
                      <Spacer />
                      <Box w="45%">
                        <SubmitButton name="Print" />
                      </Box>
                    </Flex>
                  </>
                )}
              </BoxCard>
            </Box>
          </Flex>
          <ErrorHelper toastResponse={toast} />
        </form>
      )}
    </>
  );
};

export default SurveyReports;
